import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { WhoWeAre } from "@/components/landing/WhoWeAre";
import { WhatWeDo } from "@/components/landing/WhatWeDo";
import { Approach } from "@/components/landing/Approach";
import { Statement } from "@/components/landing/Statement";
import { Development } from "@/components/landing/Development";
import { Faq } from "@/components/landing/Faq";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { PrivacyPage, TermsPage } from "@/components/landing/LegalPages";

const Landing = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <WhoWeAre />
      <WhatWeDo />
      <Approach />
      <Statement />
      <Development />
      <Faq />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
